import React, { useState, useMemo } from "react"
import { Calendar, momentLocalizer } from "react-big-calendar"
import moment from "moment"
import "react-big-calendar/lib/css/react-big-calendar.css"
import { Container, Row, Col, Card, CardBody, Input, Label } from "reactstrap"
import { FaPlus, FaX } from "react-icons/fa6"
import Breadcrumb from "components/Common/Breadcrumb"
import ActivityModal from "./addActivity"
import Configs from "../../config"
import { useNavigate } from "react-router-dom"
import Swal from "sweetalert2"

const localizer = momentLocalizer(moment)

const PlansIndex = () => {
  const navigate = useNavigate()

  const [userId, setUserId] = useState("")
  const [events, setEvents] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedDate, setSelectedDate] = useState(null)
  const [editingEvent, setEditingEvent] = useState(null) // NEW: event being edited

  const handleSaveActivity = activity => {
    if (editingEvent) {
      // Update existing event
      setEvents(prev =>
        prev.map(evt => (evt === editingEvent ? activity : evt))
      )
    } else {
      // Add new event
      setEvents(prev => [...prev, activity])
    }
    setIsModalOpen(false)
    setEditingEvent(null)
    setSelectedDate(null)
  }
  const rangeEvents = useMemo(() => (userId ? events : []), [events, userId])

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title="Fitness" breadcrumbItem="Add Fitness Plan" />

        <Card>
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div className="col-xl-3">
                <h4 className="mb-0">User Activities</h4>
              </div>
              <div className="col-xl-3">
                <Input
                  type="select"
                  value={userId}
                  onChange={e => setUserId(e.target.value)}
                >
                  <option value="">Select User</option>
                  <option value="1">F25k User1</option>
                </Input>
              </div>
            </div>

            <div className="Seprator" />
            <Row>
              <Col xl={4}></Col>
            </Row>

            {userId && (
              <Card className="bg-light mt-3">
                <CardBody>
                  <Calendar
                    localizer={localizer}
                    events={rangeEvents}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: 500 }}
                    views={["month", "week", "day"]}
                    defaultView="month"
                    selectable
                    onSelectSlot={slotInfo => {
                      const today = moment().startOf("day")
                      const selectedDate = moment(slotInfo.start).startOf("day")

                      if (selectedDate.isBefore(today)) {
                        Swal.fire({
                          icon: "warning",
                          // title: "Past Date",
                          text: "You can not create activities for past dates.",
                        })
                        return
                      }

                      setSelectedDate(slotInfo.start)
                      setEditingEvent(null)
                      setIsModalOpen(true)
                    }}
                    onSelectEvent={event => {
                      setSelectedDate(event.start)
                      setEditingEvent(event) // Pass the event to edit
                      setIsModalOpen(true)
                    }}
                  />
                </CardBody>
              </Card>
            )}
          </CardBody>
        </Card>

        <ActivityModal
          isOpen={isModalOpen}
          toggle={() => {
            setIsModalOpen(false)
            setEditingEvent(null)
            setSelectedDate(null)
          }}
          onSave={handleSaveActivity}
          date={selectedDate}
          event={editingEvent}
        />
      </Container>
    </div>
  )
}

export default PlansIndex
